<template>
  <transition name="sidebar-media-dialog-fade">
    <div v-if="visible" class="sidebar-media-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭媒体预览弹窗" @click="handleClose">
          <img src="../../../assets/home-confirm/dialogs/contact-close.svg" alt="" class="close-icon" />
        </button>

        <p v-if="title" class="title">{{ title }}</p>

        <div class="content">
          <video v-if="videoSrc" :src="videoSrc" :poster="imageSrc" class="media media-video" controls autoplay
            playsinline preload="metadata" />
          <img v-else-if="imageSrc" :src="imageSrc" :alt="title || '媒体预览'" class="media media-image" />
          <div v-else class="empty">暂无内容</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SidebarMediaDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    imageSrc: {
      type: String,
      default: "",
    },
    videoSrc: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.sidebar-media-dialog {
  position: fixed;
  inset: 0;
  z-index: 1997;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 960px;
  max-width: calc(100vw - 48px);
  max-height: 80vh;
  padding: 44px 32px 32px;
  background: #ffffff;
}

.close {
  position: absolute;
  top: 15px;
  right: 17px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.close-icon {
  width: 14px;
  height: 14px;
}

.title {
  margin: 0 0 20px;
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px;
}

.media {
  display: block;
  max-width: 100%;
  max-height: calc(80vh - 160px);
}

.media-image {
  object-fit: contain;
}

.media-video {
  background: #000000;
}

.empty {
  color: #999999;
  font-size: 18px;
  line-height: 24px;
}

.sidebar-media-dialog-fade-enter-active,
.sidebar-media-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.sidebar-media-dialog-fade-enter-active .panel,
.sidebar-media-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.sidebar-media-dialog-fade-enter,
.sidebar-media-dialog-fade-enter-from,
.sidebar-media-dialog-fade-leave-to {
  opacity: 0;
}

.sidebar-media-dialog-fade-enter .panel,
.sidebar-media-dialog-fade-enter-from .panel,
.sidebar-media-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
<style scoped src="./SidebarMediaDialog.mobile.css"></style>
